import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrackingService } from './services/tracking.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    TrackingService
  ]
})

export class CoreModule { }
